import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {API} from "../../app/services/api.service";
import {COMPLETE_PAYLOAD} from "../../app/constants/config";
import {Customer} from "../../app/classes/customer";
import {Http} from "@angular/http";

/*
  Generated class for the OpeningTimes page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-opening-times',
  templateUrl: 'opening-times.html'
})
export class OpeningTimesPage {
  public customer;
  public errorMessage;

  constructor(private api : API, public navCtrl: NavController,public http : Http, public navParams: NavParams) {
    this.customer = Customer.cachedOrCreate(this.http);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OpeningTimesPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/opening-times/opening-times.ts